var _rect, _path, _path2, _path3, _rect2, _rect3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBuilding1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 95,
    height: 389,
    viewBox: "0 0 95 389",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 95,
    height: 389,
    fill: "#1E252F"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.1111 345H73.8889V389H21.1111V345Z",
    fill: "#25C6DC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.3889 356H43.2778V389H26.3889V356Z",
    fill: "#7E24F0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M51.7222 356H68.6111V389H51.7222V356Z",
    fill: "#7E24F0"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 21.1111,
    y: 70,
    width: 20.0556,
    height: 268,
    fill: "#7E24F0"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 53.8333,
    y: 70,
    width: 20.0556,
    height: 268,
    fill: "#7E24F0"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuilding1);
export default __webpack_public_path__ + "static/media/Building1.d11b25860f266e279420cf61473dcf77.svg";
export { ForwardRef as ReactComponent };